import { MatchStateFilter, TournamentStateFilter } from '@okletsplay/core';
import { Route } from 'app/enums';
import { SessionState } from 'app/store/session/interfaces';
import { initialState } from './adapter';

export const setRedirectReducer = (
  state: SessionState,
  action: { payload: { pathname: string | Route; search: string } }
): void => {
  if (action.payload) {
    state.entity.redirect = action.payload;
  }
};

export const setIsChatPinnedReducer = (state: SessionState, action: { payload: boolean }): void => {
  state.entity.isChatPinned = action.payload;
};

export const setIsLeaderboardExpandedReducer = (
  state: SessionState,
  action: { payload: boolean }
): void => {
  state.entity.isLeaderboardExpanded = action.payload;
};

export const setMatchFilterReducer = (
  state: SessionState,
  action: { payload: MatchStateFilter }
): void => {
  state.entity.matchFilter = action.payload;
};

export const setTournamentFilterReducer = (
  state: SessionState,
  action: { payload: TournamentStateFilter }
): void => {
  state.entity.tournamentFilter = action.payload;
};

export const resetStateReducer = (state: SessionState): void => {
  state.entity = initialState.entity;
};
